const settings = {
    appName: process.env.VUE_APP_NAME,
    endPoint: process.env.VUE_APP_ENPOINT_BACKEND,
    endPointApp: process.env.VUE_APP_ENPOINT_APP,
    appType: process.env.VUE_APP_ENV,
    endPointBilling: process.env.VUE_APP_ENPOINT_BILLING,
    endPointWhatsapp: process.env.VUE_APP_ENPOINT_WHATSAPP,
    endPointBlujay: process.env.VUE_APP_ENPOINT_BLUJAY,
    endPointBlujayBca: process.env.VUE_APP_ENPOINT_BLUJAY_BCA,
    endPointFluxOms: process.env.VUE_APP_ENPOINT_FLUX_OMS,
    endPointCeisa: process.env.VUE_APP_ENPOINT_CEISA,
    endpointSurvey: process.env.VUE_APP_ENDPOINT_SURVEY,
    endpointWhMonitoring: process.env.VUE_APP_ENDPOINT_WH_MONITORING,
    jwtSecret: process.env.VUE_APP_JWT_SECRET,
  }

export default settings;